import { Component } from 'react';
import ga from '../../utils/gaConnect';
import { isProductionMode } from '../../utils/util';

class ErrorBoundary extends Component {
  state = {
    error: false
  };

  componentDidCatch(error, info) {
    /*  console.log('에러가 발생했습니다.');
    console.log({
      error,
      info
    }); */
    this.setState({
      error: true
    });

    //debugger;

    ga.exception({
      description: `
    message : ${error.message}
    call stack : ${info.componentStack}
    `
    });

    if (isProductionMode()) {
      //ga.exception();
      //Sentry.captureException(error, { extra: info });
    }
  }

  render() {
    if (this.state.error) {
      //return <h1>에러 발생!</h1>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
